import { constants } from './constants';
import { format, add } from 'date-fns'

/** 汎用処理群 */
export const utility = {

  /**
   * 日付表示形式への変換
   * @param {string} value
   * @param {string} formatDate
   * @returns
   */
  formatDate: (value, formatDate) => {
    return value ? format(new Date(value), formatDate ?? 'yyyy/M/d') : '';
  },

  /**
   * 日時表示形式への変換
   * @param {string} value
   * @param {string} formatDate
   * @returns
   */
  formatDateTime: (value, formatDate) => {
    return value ? format(new Date(value), formatDate ?? 'yyyy/M/d HH:mm:ss') : '';
  },

  /**
   * 最終時刻日付を取得
   * @param {string} value
   * @returns
   */
  getLastTimeDate: (value) => {
    return value ? add(new Date(value), { days: 1, seconds: -1 }) : '';
  },

  // 2024.5.8 MyMine Version1.5対応 Add Start
  /**
   * 日付を英圏内フォーマットに変換
   * @param {string} value 日付文字列
   * @returns
   */
  convertEnglishDateFormat: (value) => {
    return value ? new Intl.DateTimeFormat('en-GB', {
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(new Date(value)) : '';
  },
  // 2024.5.8 MyMine Version1.5対応 Add End

  /**
   * 省略文字列フォーマットへの変換
   * @param {string} orgStr 変換対象文字列
   * @param {Number} dispLength 表示文字数上限
   * @returns
   */
  convertEllipsisFormat: (orgStr, dispLength) => {
    let strResult = orgStr;
    if (orgStr && orgStr.length > dispLength) {
      strResult = orgStr.substring(0, dispLength) + constants.EllipsisChars;
    }
    return strResult;
  },

  /**
   * オブジェクトをエンコードしたURLパラメータに変換して返す
   * @param {any} parameterObject
   * @returns
   */
  makeEncodeParameter: (parameterObject) => {
    return Object.entries(parameterObject).map((x) => `${x[0]}=${encodeURIComponent(x[1] ?? '')}`).join('&');

  },

  /**
   * サニタイズ
   * @param {any} value
   * @returns
   */
  sanitize: (value) => {

    if (typeof value !== 'string') {
      return value;
    }

    if (value === null || value === undefined) {
      return '';
    }

    return value
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  },

  /**
   * ファイルサイズ変換
   * @param {Number} fileSizeByte 変換前ファイルサイズ
   * @param {Number} fileSizeUnit 変換単位 constants.FileSizeに準拠
   * @returns 変換後ファイルサイズ
   */
  convertFileSize: (fileSizeByte, fileSizeUnit) => {
    let resultFileSize = fileSizeByte;
    if (fileSizeUnit === constants.FileSize.B)
      return resultFileSize;

    resultFileSize /= 1024;

    if (fileSizeUnit === constants.FileSize.KB)
      return resultFileSize;

    resultFileSize /= 1024;

    if (fileSizeUnit === constants.FileSize.MB) {
      return resultFileSize;
    }

    throw new Error(`FileSize: ${fileSizeUnit} はサポートされていません`);
  },

  /** トップページ遷移 */
  transferTopPage: () => {
    // navigate遷移だと、トップページに遷移した際にトレイリングスラッシュが付かず挙動が怪しくなるため、Location書き換えで遷移する
    document.location.href = `${document.location.origin}${process.env.REACT_APP_BASE_URL}/`;
  }
}


